import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Submit a form payload to a backend route. Returns response data or throws.
export async function submitForm(path, body) {
  const { data } = await axios.post(`${API}${path}`, body, {
    headers: { "Content-Type": "application/json" },
  });
  return data;
}

// Authenticated GET for the hidden admin submissions view.
export async function adminFetch(path, token) {
  const { data } = await axios.get(`${API}${path}`, {
    headers: { "X-Admin-Token": token },
  });
  return data;
}

// Friendly error message from an axios error.
export function errMessage(e, fallback = "Something went wrong. Please try again.") {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail) && detail[0]?.msg) return detail[0].msg;
  return fallback;
}
